import InfoMessage from "../../components/AlertMessage/InfoMessage.vue";
import Preloader from "@/components/Preloader/Preloader.vue";
export default {
    name: 'TermsOfService',
    data () {
        return {
            showPreloader: true
        }
    },
    mounted() {
      setTimeout(() => {
          this.showPreloader = false
      }, 500)
    },
    components: {
        InfoMessage,
        Preloader
    }
}
